const getTokenDisplayName = (creditCardName: string) => {
    const splitCreditCardName = creditCardName.split("|");

    if(splitCreditCardName.length === 4){
        return `${splitCreditCardName[3]} - ${splitCreditCardName[0].substring(splitCreditCardName[0].length - 4)}`;
    }
        
    return creditCardName;
};

export default getTokenDisplayName;